import Checkout from "../../../../Components/User/Events/Checkout/Checkout";
import Layout from "../../../../Components/Layout";
import { useParams } from "react-router-dom";

const CheckoutFormPage = () => {
  const { eventId } = useParams();
  const query = new URLSearchParams(window.location.search);
  const referralId = query.get("referralId");
  let redirectUrl = "/attendee-information/" + eventId;
  if (referralId) {
    redirectUrl += `?referralId=${referralId}`;
  }
  return (
    <Layout Heading="Checkout" TitleClassName="event-checkout-title" HeadClassName="event-page-head event-checkout-head" DetailsHead LeftClassName="event-checkout-head-left" Sidebar={0} BackAction={redirectUrl} ExtraclassName="event-checkout-panel">
      <Checkout eventId={eventId} />
    </Layout>
  );
};

export default CheckoutFormPage;
